export const PopupEnum = {
    CREATE: {
        id: "create-modal",
        title: "Δημιουργία νέας εγγραφής",
        type: "create"
    },
    EDIT: {
        id: "edit-modal",
        title: "Επεξεργασία εγγραφής",
        type: "info"
    },
    CREATE_INTERNAL: {
        id: "create-internal-modal",
        title: "Δημιουργία νέας εγγραφής",
        type: "create"
    },
    EDIT_INTERNAL: {
        id: "edit-internal-modal",
        title: "Επεξεργασία εγγραφής",
        type: "info"
    },
    DELETE: {
        id: "delete-modal",
        title: "Διαγραφή εγγραφής",
        type: "delete"
    },
    INFO: {
        id: "info-modal",
        title: "Πληροφορίες εγγραφής",
        type: "info"
    },
    UNSAVED_CHANGES: {
        id: "info-modal",
        title: 'Έξοδος',
        type: "info"
    },
    NO_MODAL: {
        id: "no-modal",
        title: 'Προσοχή μη αποθηκευμένες εγγραφές',
        type: "info"
    }
}
export const YesNoEnum = {
    yesNo:
        [
            {
                value: true,
                text: "Ναι",
            },
            {
                value: false,
                text: "Οχι",
            }
        ]
}
export const NO_ORIO_ERROR = "Η ενημέρωση δεν πραγματοποιήθηκε διότι δεν υπάρχουν όρια για το έτος."


export const IsTaxisData = {
    isTaxisData:
        [
            {
                value: {id: 1, desc: 'E9'},
                text: "E9",
            },
            {
                value: {id: 2, desc: 'E1'},
                text: "E1",
            }
        ]
}

export const IsAnalhpsh = {
    isAnalhpsh:
        [
            {
                value: false,
                text: "Ετήσια",
            },
            {
                value: true,
                text: "Αρχική",
            }
        ]
}

export const IsDocType = {
    isDocType:
        [
            {
                value: "Έντυπο Ε1",
                text: "Έντυπο Ε1",
            },
            {
                value: "Έντυπο Ε9",
                text: "Έντυπο Ε9",
            },
            {
                value: "Έγγραφο Εσόδων",
                text: "Έγγραφο Εσόδων",
            },
            {
                value: "Έγγραφο Επενδυτικών προϊόντων",
                text: "Έγγραφο Επενδυτικών προϊόντων",
            },
            {
                value: "Έγγραφο Λογαριασμών",
                text: "Έγγραφο Λογαριασμών",
            },
            {
                value: "Έγγραφο Μέσων",
                text: "Έγγραφο Μέσων",
            },
            {
                value: "Έγγραφο Επιχειρήσεων",
                text: "Έγγραφο Επιχειρήσεων",
            },
            {
                value: "Έγγραφο Ακινήτων",
                text: "Έγγραφο Ακινήτων",
            },
            {
                value: "Έγγραφο Θυρίδων",
                text: "Έγγραφο Θυρίδων",
            },
            {
                value: "Έγγραφο Κινητών Μεγάλης Αξίας",
                text: "Έγγραφο Κινητών Μεγάλης Αξίας",
            },
            {
                value: "Άλλο",
                text: "Άλλο",
            },
        ]
}

export const XopiDocType = {
    xopiDocType:
        [
            {
                value: "Φόρμα ενεργοποίησης",
                text: "Φόρμα ενεργοποίησης",
            },
            {
                value: "Εξουσιοδότηση Χρήστη",
                text: "Εξουσιοδότηση Χρήστη",
            },
            {
                value: "Εξαίρεση Διαλειτουργικότητας",
                text: "Εξαίρεση Διαλειτουργικότητας",
            },
            {
                value: "Εξαίρεση Θεματοφυλακής",
                text: "Εξαίρεση Θεματοφυλακής",
            },
            {
                value: "Λοιπά έγγραφα ΦΔ",
                text: "Λοιπά έγγραφα ΦΔ",
            },
            {
                value: "Άλλο",
                text: "Άλλο",
            },
        ]
}

export const trapezesList = {
    trapezes: [
        {id: null, value: null, text: 'Επιλέξτε τιμή...', based: null},
        {id: '011', value: 'ΕΘΝΙΚΗ ΤΡΑΠΕΖΑ ΤΗΣ ΕΛΛΑΔΟΣ Α.Ε.', text: 'ΕΘΝΙΚΗ ΤΡΑΠΕΖΑ ΤΗΣ ΕΛΛΑΔΟΣ Α.Ε.', based: 'GR'},
        {id: '014', value: 'ΑΛΦΑ ΤΡΑΠΕΖΑ ΑΝΩΝΥΜΗ ΕΤΑΙΡΙΑ', text: 'ΑΛΦΑ ΤΡΑΠΕΖΑ ΑΝΩΝΥΜΗ ΕΤΑΙΡΙΑ', based: 'GR'},
        {
            id: '016',
            value: 'ATTICA finInstitutions, ΑΝΩΝΥΜΗ ΤΡΑΠΕΖΙΚΗ ΕΤΑΙΡΕΙΑ',
            text: 'ATTICA finInstitutions, ΑΝΩΝΥΜΗ ΤΡΑΠΕΖΙΚΗ ΕΤΑΙΡΕΙΑ',
            based: 'GR'
        },
        {id: '017', value: 'ΤΡΑΠΕΖΑ ΠΕΙΡΑΙΩΣ Α.Ε.', text: 'ΤΡΑΠΕΖΑ ΠΕΙΡΑΙΩΣ Α.Ε.', based: 'GR'},
        {
            id: '026',
            value: 'ΤΡΑΠΕΖΑ  EUROfinInstitutions ΑΝΩΝΥΜΗ ΕΤΑΙΡΕΙΑ',
            text: 'ΤΡΑΠΕΖΑ  EUROfinInstitutions ΑΝΩΝΥΜΗ ΕΤΑΙΡΕΙΑ',
            based: 'GR'
        },
        {
            id: '034',
            value: 'ΤΡΑΠΕΖΑ OPTIMA finInstitutions Α.Ε.',
            text: 'ΤΡΑΠΕΖΑ OPTIMA finInstitutions Α.Ε.',
            based: 'GR'
        },
        {
            id: '056',
            value: 'AEGEAN BALTIC finInstitutions Α.Τ.Ε.',
            text: 'AEGEAN BALTIC finInstitutions Α.Τ.Ε.',
            based: 'GR'
        },
        {
            id: '057',
            value: 'VIVAfinInstitutions ΜΟΝΟΠΡΟΣΩΠΗ ΑΝΩΝΥΜΗ ΤΡΑΠΕΖΙΚΗ ΕΤΑΙΡΕΙΑ',
            text: 'VIVAfinInstitutions ΜΟΝΟΠΡΟΣΩΠΗ ΑΝΩΝΥΜΗ ΤΡΑΠΕΖΙΚΗ ΕΤΑΙΡΕΙΑ',
            based: 'GR'
        },
        {
            id: '069',
            value: 'ΣΥΝΕΤΑΙΡΙΣΤΙΚΗ ΤΡΑΠΕΖΑ ΧΑΝΙΩΝ ΣΥΝ.Π.Ε.',
            text: 'ΣΥΝΕΤΑΙΡΙΣΤΙΚΗ ΤΡΑΠΕΖΑ ΧΑΝΙΩΝ ΣΥΝ.Π.Ε.',
            based: 'GR'
        },
        {
            id: '075',
            value: 'ΣΥΝΕΤΑΙΡΙΣΤΙΚΗ ΤΡΑΠΕΖΑ ΗΠΕΙΡΟΥ ΣΥΝ.ΠΕ.',
            text: 'ΣΥΝΕΤΑΙΡΙΣΤΙΚΗ ΤΡΑΠΕΖΑ ΗΠΕΙΡΟΥ ΣΥΝ.ΠΕ.',
            based: 'GR'
        },
        {
            id: '087',
            value: 'ΠΑΓΚΡΗΤΙΑ ΤΡΑΠΕΖΑ ΑΝΩΝΥΜΗ ΕΤΑΙΡΕΙΑ',
            text: 'ΠΑΓΚΡΗΤΙΑ ΤΡΑΠΕΖΑ ΑΝΩΝΥΜΗ ΕΤΑΙΡΕΙΑ',
            based: 'GR'
        },
        {
            id: '089',
            value: 'ΣΥΝΕΤΑΙΡΙΣΤΙΚΗ ΤΡΑΠΕΖΑ ΚΑΡΔΙΤΣΑΣ ΣΥΝ.Π.Ε.',
            text: 'ΣΥΝΕΤΑΙΡΙΣΤΙΚΗ ΤΡΑΠΕΖΑ ΚΑΡΔΙΤΣΑΣ ΣΥΝ.Π.Ε.',
            based: 'GR'
        },
        {
            id: '091',
            value: 'ΣΥΝΕΤΑΙΡΙΣΤΙΚΗ ΤΡΑΠΕΖΑ ΘΕΣΣΑΛΙΑΣ ΣΥΝ.Π.Ε.',
            text: 'ΣΥΝΕΤΑΙΡΙΣΤΙΚΗ ΤΡΑΠΕΖΑ ΘΕΣΣΑΛΙΑΣ ΣΥΝ.Π.Ε.',
            based: 'GR'
        },
        {
            id: '095',
            value: 'ΣΥΝΕΤΑΙΡΙΣΤΙΚΗ ΤΡΑΠΕΖΑ ΟΛΥΜΠΟΣ ΣΥΝ.Π.Ε.',
            text: 'ΣΥΝΕΤΑΙΡΙΣΤΙΚΗ ΤΡΑΠΕΖΑ ΟΛΥΜΠΟΣ ΣΥΝ.Π.Ε.',
            based: 'GR'
        },
        {
            id: '099',
            value: 'ΣΥΝΕΤΑΙΡΙΣΤΙΚΗ ΤΡΑΠΕΖΑ ΚΕΝΤΡΙΚΗΣ ΜΑΚΕΔΟΝΙΑΣ ΣΥΝ.Π.Ε.',
            text: 'ΣΥΝΕΤΑΙΡΙΣΤΙΚΗ ΤΡΑΠΕΖΑ ΚΕΝΤΡΙΚΗΣ ΜΑΚΕΔΟΝΙΑΣ ΣΥΝ.Π.Ε.',
            based: 'GR'
        },
        {id: '039', value: 'BNP PARIBAS SECURITIES SERVICES', text: 'BNP PARIBAS SECURITIES SERVICES', based: 'EU'},
        {id: '040', value: 'FCA finInstitutions GmbH', text: 'FCA finInstitutions GmbH', based: 'EU'},
        {id: '071', value: 'HSBC CONTINENTAL EUROPE,GREECE', text: 'HSBC CONTINENTAL EUROPE,GREECE', based: 'EU'},
        {
            id: '073',
            value: 'ΤΡΑΠΕΖΑ ΚΥΠΡΟΥ ΔΗΜΟΣΙΑ ΕΤΑΙΡΕΙΑ ΛΤΔ *',
            text: 'ΤΡΑΠΕΖΑ ΚΥΠΡΟΥ ΔΗΜΟΣΙΑ ΕΤΑΙΡΕΙΑ ΛΤΔ *',
            based: 'EU'
        },
        {
            id: '081',
            value: 'finInstitutions OF AMERICA EUROPE DESIGNATED ACTIVITY COMPANY, ATHENS BRANCH',
            text: 'finInstitutions OF AMERICA EUROPE DESIGNATED ACTIVITY COMPANY, ATHENS BRANCH',
            based: 'EU'
        },
        {
            id: '084',
            value: 'CITIfinInstitutions EUROPE PLC (CEP)',
            text: 'CITIfinInstitutions EUROPE PLC (CEP)',
            based: 'EU'
        },
        {id: '102', value: 'VOLKSWAGEN finInstitutions GmbH', text: 'VOLKSWAGEN finInstitutions GmbH', based: 'EU'},
        {id: '105', value: 'BMW AUSTRIA finInstitutions GmbH', text: 'BMW AUSTRIA finInstitutions GmbH', based: 'EU'},
        {id: '111', value: 'DEUTSCHE finInstitutions AG', text: 'DEUTSCHE finInstitutions AG', based: 'EU'},
        {
            id: '115',
            value: 'HAMBURG COMMERCIAL finInstitutions AG',
            text: 'HAMBURG COMMERCIAL finInstitutions AG',
            based: 'EU'
        },
        {
            id: '116',
            value: 'PROCREDIT finInstitutions (BULGARIA) EAD',
            text: 'PROCREDIT finInstitutions (BULGARIA) EAD',
            based: 'EU'
        },
        {
            id: '118',
            value: 'EFG finInstitutions (LUXEMBOURG) S.A',
            text: 'EFG finInstitutions (LUXEMBOURG) S.A',
            based: 'EU'
        },
        {id: '119', value: 'ABN AMRO finInstitutions N.V', text: 'ABN AMRO finInstitutions N.V', based: 'EU'},
        {
            id: '121',
            value: 'finInstitutions OF CHINA (EUROPE) S.A.-ΥΠΟΚΑΤΑΣΤΗΜΑ ΑΘΗΝΑΣ',
            text: 'finInstitutions OF CHINA (EUROPE) S.A.-ΥΠΟΚΑΤΑΣΤΗΜΑ ΑΘΗΝΑΣ',
            based: 'EU'
        },
        {
            id: '122',
            value: 'BFF finInstitutions S.p.A.-ΕΛΛΗΝΙΚΟ ΥΠΟΚΑΤΑΣΤΗΜΑ',
            text: 'BFF finInstitutions S.p.A.-ΕΛΛΗΝΙΚΟ ΥΠΟΚΑΤΑΣΤΗΜΑ',
            based: 'EU'
        },
        {id: '123', value: 'SANTANDER CONSUMER FINANCE S.A', text: 'SANTANDER CONSUMER FINANCE S.A', based: 'EU'},
        {id: '124', value: 'J.P. MORGAN SE-ATHENS BRANCH', text: 'J.P. MORGAN SE-ATHENS BRANCH', based: 'EU'},
        {
            id: '125',
            value: 'TBI finInstitutions EAD- BRANCH GREECE',
            text: 'TBI finInstitutions EAD- BRANCH GREECE',
            based: 'EU'
        },
        {
            id: '126',
            value: 'ΓΚΟΛΝΤΜΑΝ ΣΑΚΣ ΜΠΑΝΚ ΓΙΟΥΡΟΠ ΣΕ,ΥΠΟΚΑΤΑΣΤΗΜΑ ΑΘΗΝΩΝ',
            text: 'ΓΚΟΛΝΤΜΑΝ ΣΑΚΣ ΜΠΑΝΚ ΓΙΟΥΡΟΠ ΣΕ,ΥΠΟΚΑΤΑΣΤΗΜΑ ΑΘΗΝΩΝ',
            based: 'EU'
        },
        {id: '050', value: 'finInstitutions SADERAT IRAN', text: 'finInstitutions SADERAT IRAN', based: 'NON-EU'},
        {
            id: '109',
            value: 'T.C. ZIRAAT finInstitutionsASI A.S.',
            text: 'T.C. ZIRAAT finInstitutionsASI A.S.',
            based: 'NON-EU'
        },
        {
            id: '5000',
            value: 'ΑΛΛΟ ΤΡΑΠΕΖΙΚΟ ΙΔΡΥΜΑ.',
            text: 'ΑΛΛΟ ΤΡΑΠΕΖΙΚΟ ΙΔΡΥΜΑ.',
            based: 'GR'
        },
    ]
}
export const PENDING_APPROVAL = 'Εκκρεμεί Έγκριση'
export const INVALID_DATE = 'Invalid date'

export const ResponseModel = {
    fields: [],
    form: {}
}

export const SORT_TYPE = {
    ASC: 'asc',
    DESC: 'desc'
}

export const ButtonTableTypeEnum = {
    DEFAULT: 'default',
    MANUAL: 'manual',
    MIXED: 'mixed',
}
export const MonthsEnum = {
    months: [
        // {value: 0, text:  '-'},
        {value: 1, text: 'Ιανουάριος'},
        {value: 2, text: 'Φεβρουάριος'},
        {value: 3, text: 'Μάρτιος'},
        {value: 4, text: 'Απρίλιος'},
        {value: 5, text: 'Μάιος'},
        {value: 6, text: 'Ιούνιος'},
        {value: 7, text: 'Ιούλιος'},
        {value: 8, text: 'Αύγουστος'},
        {value: 9, text: 'Σεπτέμβριος'},
        {value: 10, text: 'Οκτώβριος'},
        {value: 11, text: 'Νοέμβριος'},
        {value: 12, text: 'Δεκέμβριος'}
    ]
}

export const WsOrFtpsEnum = {
    wsOrFtps:
        [
            {
                value: 1,
                text: "Web service",
            },
            {
                value: 2,
                text: "FTPS",
            }
        ]
}

export const TyposKatalogouEnum = {
    typosKatalogou:
        [
            {
                value: 0,
                text: "Ετήσια",
            },
            {
                value: 1,
                text: "Αρχική",
            }
        ]
}

export const ApotelesmaParalavisEnum = {
    apotelesmaParalavis:
        [
            {
                value: 0,
                text: "Success",
            },
            {
                value: 1,
                text: "Errors",
            }
        ]
}

export const TyposApostolisEnum = {
    typosApostolis:
        [
            {
                value: 1,
                text: "Απάντηση αιτήματος από ΧΟ-ΠΙ",
            },
            {
                value: 2,
                text: "Αποστολή αιτήματος σε ΧΟ-ΠΙ",
            }
        ]
}

export const ProgTaskEnum = {
    progTask:
        [
            {value: -1, text: 'Άγνωστο'},
            {value: 0, text: 'Σε εκκρεμότητα'},
            {value: 100, text: 'Ολοκληρωμένο'},
        ]
}
export const EidosDhloshsEnum = {
    eidosDhloshs:
        [
            {value: 1, text: 'Ετήσιες'},
            {value: 2, text: 'Αρχικές'},
            {value: 3, text: 'Αρχικές και Ετήσιες'},
        ]
}
export const EpopthsEnum = {
    epopths:
        [
            {value: 1, text: 'ΤτΕ'},
            {value: 2, text: 'ΤτΕ\\ΕΕΤ'},
            {value: 3, text: 'ΕπΚεφ'},
            {value: 4, text: 'Αλλο'},
        ]
}
export const KathgoriaEnum = {
    kathgoria:
        [
            {value: 1, text: ' Πιστωτικά ιδρύματα'},
            {value: 2, text: 'Ασφαλιστικές επιχειρήσεις που ασκούν δραστηριότητες ασφαλίσεων ζωής'},
            {value: 3, text: 'Εταιρείες χρηματοδοτικής μίσθωσης'},
            {
                value: 4,
                text: 'Εταιρείες διαχείρισης απαιτήσεων πιστωτικών ιδρυμάτων από δάνεια και πιστώσεις και τους διαχειριστές πιστώσεων'
            },
            {value: 5, text: 'Εταιρείες παροχής πιστώσεων'},
            {value: 6, text: 'Ιδρύματα ηλεκτρονικού χρήματος'},
            {value: 7, text: 'Ιδρύματα πληρωμών'},
            {value: 8, text: 'Ταχυδρομικές εταιρείες, ως προς τις παρεχόμενες υπηρεσίες πληρωμών'},
            {value: 9, text: 'Εταιρείες μίσθωσης θυρίδων'},
            {value: 10, text: 'Ιδρύματα μικροχρηματοδοτήσεων'},
            {
                value: 11,
                text: 'Εταιρείες επενδύσεων χαρτοφυλακίου μέχρι την εισαγωγή τους σε ρυθμιζόμενη αγορά ή πολυμερή μηχανισμό διαπραγμάτευσης'
            },
            {value: 12, text: 'Εταιρείες διαχείρισης αμοιβαίων κεφαλαίων'},
            {value: 13, text: 'Εταιρείες παροχής επενδυτικών υπηρεσιών και τους συνδεδεμένους αντιπροσώπους τους'},
            {value: 14, text: 'Εταιρείες επενδυτικής διαμεσολάβησης'},
            {
                value: 15,
                text: 'Εταιρείες κεφαλαίου επιχειρηματικών συμμετοχών μέχρι την εισαγωγή τους σε ρυθμιζόμενη αγορά ή πολυμερή μηχανισμό διαπραγμάτευσης'
            },
            {
                value: 16,
                text: 'Εταιρείες επενδύσεων σε ακίνητη περιουσία μέχρι την εισαγωγή τους σε ρυθμιζόμενη αγορά ή πολυμερή μηχανισμό διαπραγμάτευσης'
            },
            {value: 17, text: 'Διαχειριστές οργανισμών εναλλακτικών επενδύσεων'},
            {value: 18, text: 'Πάροχοι υπηρεσιών θεματοφυλακής ψηφιακών πορτοφολιών'},
            {value: 19, text: 'Άλλο'}
        ]
}